// src/Dashboard/pages/user/CalendarEvents/utils/calendarEventsUtils.js

export const DEFAULT_UI_STATE = {
  search: "",
  category: "all",
  type: "all",
  level: "all",
  status: "upcoming", // all | upcoming | past
  favoriteOnly: false,
  sort: "dateAsc", // dateAsc | dateDesc | title
  perPage: 12,
};

export const BASE_EVENT_TYPES = [
  "Tournoi Interclubs",
  "Cours commun club",
  "Stage Club",
  "Compétition",
  "Animation",
  "Stage & Regroupement Technique",
  "Passage de Grade",
  "Entraînement Départemental",
  "Stage Sportif Départemental",
  "Autre",
];

export const FIXED_EVENT_LEVELS = [
  "Club",
  "Départemental",
  "Régional",
  "National",
  "International",
];

export const FIXED_EVENT_CATEGORIES = [
  "Eveil",
  "Mini-Poussin(e)",
  "Poussin(e)",
  "Benjamin(e)",
  "Minime",
  "Cadet(te)",
  "Junior",
  "Sénior",
  "Vétéran",
];

export const collatorFR = new Intl.Collator("fr", { sensitivity: "base" });

export const strip = (value = "") =>
  String(value || "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim();

export const isActiveEvent = (event) => {
  return event?.is_active !== false && event?.is_active !== 0;
};

export const getEventDate = (value) => {
  if (!value) return null;

  const date = value instanceof Date ? value : new Date(value);

  return Number.isNaN(date.getTime()) ? null : date;
};

export const startOfDay = (value) => {
  const date = getEventDate(value);

  if (!date) return null;

  const copy = new Date(date);
  copy.setHours(0, 0, 0, 0);

  return copy;
};

export const isEventPast = (event) => {
  const today = startOfDay(new Date());
  const end = startOfDay(event?.end || event?.start);

  if (!today || !end) return false;

  return end < today;
};

export const getEventCategories = (event) => {
  if (typeof event?.cate_event !== "string") return [];

  return event.cate_event
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
};

export const getUserId = () => {
  try {
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");

    return userInfo?.userId || userInfo?.id || userInfo?.user?.id || null;
  } catch {
    return null;
  }
};

export const getStoredUserToken = () => {
  try {
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");

    return userInfo?.token || localStorage.getItem("token") || "";
  } catch {
    return localStorage.getItem("token") || "";
  }
};

export const stripHtml = (html = "") => {
  if (typeof document === "undefined") {
    return String(html || "").replace(/<[^>]*>/g, " ").trim();
  }

  const div = document.createElement("div");
  div.innerHTML = html;

  return (div.textContent || div.innerText || "").trim();
};

export const truncate = (value = "", max = 150) => {
  const text = String(value || "").trim();

  if (text.length <= max) return text;

  return `${text.slice(0, max)}…`;
};

export const formatDate = (value) => {
  const date = getEventDate(value);

  if (!date) return "Date à préciser";

  return new Intl.DateTimeFormat("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
};

export const formatHour = (value) => {
  const date = getEventDate(value);

  if (!date) return "";

  return new Intl.DateTimeFormat("fr-FR", {
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
};

export const formatDateRange = (event) => {
  const start = getEventDate(event?.start);
  const end = getEventDate(event?.end);

  if (!start) return "Date à préciser";

  const startLabel = formatDate(start);
  const startHour = formatHour(start);

  if (!end) {
    return startHour ? `${startLabel} · ${startHour}` : startLabel;
  }

  const sameDay = start.toDateString() === end.toDateString();

  if (sameDay) {
    const endHour = formatHour(end);

    return `${startLabel}${startHour ? ` · ${startHour}` : ""}${
      endHour ? ` - ${endHour}` : ""
    }`;
  }

  return `${startLabel} - ${formatDate(end)}`;
};

export const normalizeCount = (value) => {
  if (typeof value === "number") return value;
  if (value?.count !== undefined) return Number(value.count || 0);
  if (value?.total !== undefined) return Number(value.total || 0);

  return Number(value || 0);
};